//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const initalState = {
    classActivity: false,
    classQuiz: false
};

export const loaderClassActivityAndQuiz = (state = initalState, action) => {
    switch (action.type) {
        case ActionTypes.loaderQuizAndActivity.getLoaderQuizAndActivity:
            return state;
        case ActionTypes.loaderQuizAndActivity.setLoaderQuizAndActivity:
            return {...state, ...action.payload}
        default:
            return state;
    }
};
